import { Link } from "react-router-dom"
import {
  Paper,
  Box,
  List,
  ListItem,
  Typography,
  Tooltip,
  styled,
} from "@mui/material"

import Button from "components/ui/Button"
import { colors } from "theme"

export const Card = styled(Paper)(({ theme }) => ({
  boxShadow: "12px 14px 23px -2px rgb(0 0 0 / 3%)",
  borderRadius: "26px",
  border: `1px solid ${colors.antiFlashWhite}`,
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "0 16px",
  padding: "38px",
  position: "relative",
  width: "30%",
  [theme.breakpoints.down("lg")]: {
    margin: "0 0 12px 0",
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    padding: "16px",
  },
}))

export const Popular = styled(Box)(() => ({
  background: colors.yellowOrange,
  borderRadius: "50px",
  color: colors.white,
  fontSize: "0.875rem",
  fontWeight: 600,
  padding: "5px 15px",
  position: "absolute",
  right: "-15px",
  top: "-12px",
}))

export const Content = styled(Box)(() => ({}))

export const Title = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.375rem",
  },
}))

export const Amount = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  fontWeight: "600",
  margin: "24px 0",
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.375rem",
  },
}))

export const Period = styled(Box)(() => ({
  margin: "0 0 22px 0",
  width: "100%",
}))

export const DescriptionList = styled(List)(() => ({
  listStyle: "disc",
  width: "100%",
}))

export const DescriptionListItem = styled(ListItem)(() => ({
  display: "list-item",
  fontSize: "0.875rem",
  fontWeight: 500,
  margin: "0",
  padding: "3px 0",
}))

export const Actions = styled(Box)(() => ({}))

export const AdditionalLink = styled(Link)(() => ({
  background: colors.brightGray,
  borderRadius: "21px",
  color: colors.romanSilver,
  display: "block",
  fontSize: "32px",
  height: "24px",
  lineHeight: "4px",
  margin: "0 auto",
  textAlign: "center",
  verticalAlign: "baseline",
  width: "44px",
}))

export const AdditionalTooltip = styled(Tooltip)(() => ({
  background: colors.brightGray,
  borderRadius: "21px",
  color: colors.romanSilver,
  display: "block",
  fontSize: "32px",
  height: "24px",
  lineHeight: "4px",
  margin: "0 auto",
  textAlign: "center",
  verticalAlign: "baseline",
  width: "44px",
}))

export const Subscribe = styled(Button)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: "21px",
  fontSize: "0.875rem",
  textTransform: "inherit",
  height: "44px",
  margin: "12px 0 0 0",
  padding: "0 20px",
  width: "175px",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
    margin: "8px 0",
    width: "100%",
  },
}))
